export default __webpack_public_path__ + "static/map-fd2724548d6215edb655c9840fe708fc.svg";